import { z } from "zod"

/**
 * ApiTracesStats
 */
export const apiTracesStats = z.record(z.number())
export type ApiTracesStats = z.infer<typeof apiTracesStats>
